import { useQuery } from "react-query";
import { MetaPage } from "@arelia-types/connection";
import { http } from "./http";

export function useMetaPages(serviceName: string, ops?: any) {
  const queryKey = `/api/connections/${serviceName}/pages`;

  return useQuery<MetaPage[]>({
    queryKey: [queryKey],
    queryFn: () => http(queryKey),
    ...ops
  });
}